import { combineReducers } from '@reduxjs/toolkit';

import { rewardsSlice } from './rewards/rewards.slice';
import { userSlice } from './user/user.slice';

export const loyaltyReducer = combineReducers({
  rewards: rewardsSlice.reducer,
  user: userSlice.reducer,
});
